import { gql, useMutation } from "@apollo/client";
import type { MutationHookOptions } from "@apollo/client";

const TEAM_MEMBER_UPDATE_MUTATION = gql`
  mutation TeamMemberUpdate(
    $id: ID!
    $name: String
    $email: String
    $phone: String
    $order: Int
    $position: String
    $description: String
    $avatar: Upload
    $listingAgentKey: String
  ) {
    updateTeamMember(
      teamMemberId: $id
      name: $name
      email: $email
      phone: $phone
      order: $order
      position: $position
      description: $description
      avatar: $avatar
      listingAgentKey: $listingAgentKey
    ) {
      teamMember {
        id
        name
        email
        phone
        order
        position
        description
        slug
        avatarLarge
        avatarMedium
        avatarThumb
      }
    }
  }
`;

interface TeamMemberUpdateVariables {
  id: string;
  name?: string;
  email?: string;
  phone?: string | null;
  order?: number | null;
  position?: string | null;
  description?: string | null;
  avatar?: File | null;
  listingAgentKey?: string;
}

interface TeamMemberUpdateData {
  updateTeamMember: {
    teamMember: {
      id: string;
      name: string;
      phone: string;
      order: number;
      position: string;
      description: string;
      slug: string;
      avatarLarge: string;
      avatarMedium: string;
      avatarThumb: string;
    };
  };
}

const useTeamMemberUpdateMutation = (
  options?: MutationHookOptions<TeamMemberUpdateData, TeamMemberUpdateVariables>,
) => {
  return useMutation<TeamMemberUpdateData, TeamMemberUpdateVariables>(
    TEAM_MEMBER_UPDATE_MUTATION,
    options,
  );
};

export { useTeamMemberUpdateMutation };
export type { TeamMemberUpdateData, TeamMemberUpdateVariables };
